module.exports = __webpack_public_path__ + "static/media/img003.1fb8545a.jpg";